var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('newsCenList',{attrs:{"list":_vm.newsList}}),_c('div',{staticClass:"newsPagination "},[_c('el-pagination',{attrs:{"page-size":_vm.limit,"layout":"prev, pager, next","total":_vm.allNum},on:{"current-change":_vm.goPagin}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }